<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width="24"
    height="24"
  ><path
    fill="#D80027"
    d="M0 0h513v342H0z"
  /><path d="M0 0h513v114H0z" /><path
    fill="#FFDA44"
    d="M0 228h513v114H0z"
  /></svg>
</template>
